import React from 'react';
import PropTypes from 'prop-types';
import { DetailedIconHome, Heading, Text, UpsellBanner } from '@zillow/constellation';
export default function EnrollUpsellBanner({ enrollmentOn }) {
  return (
    enrollmentOn === false && (
      <UpsellBanner
        {...{
          /**
           * TODO: Enable close button in RA-3688 and RA-3699. While we
           * aren't persisting the value in the backend, we'll just always
           * show the upsell banner if enrollment is off.
           */
          closeButton: null,
          heading: <Heading level={6}>Simplify tenant screening</Heading>,
          body: <Text>It’s fast and easy for renters, and free for you!</Text>,
          media: <DetailedIconHome />,
        }}
      />
    )
  );
}

EnrollUpsellBanner.propTypes = {
  enrollmentOn: PropTypes.bool,
};
